export enum ENV {
  STAGE,
  PROD,
  DEV,
}

export const isDevEnv = true

export enum AUTO_SAVE_MEDIUMS {
  SOCKET,
  HTTP,
}

export const SSO_CONFIGS: any = {
  namespace: "synapse",
  tenant: "CUREFIT",
  debug: true,
  watchmenApiKey: "synapse-stage-access",
  validateMembership: "WATCHMEN",
  watchmenUserIdKey: "email",
  fetchResources: true,
  watchmanBaseUrl: "https://watchmen.stage.curefit.co/",
  mockAuth: {
    userContext: {
      createdBy: "system",
      createdOn: 1663078446000,
      email: "sahil.yadav@sugarfit.com",
      firstName: "sahil",
      id: 58919,
      isAccountDeactivated: false,
      isActive: true,
      lastModifiedOn: 1663583174000,
      lastName: "yadav",
      name: "sahil yadav",
      phone: "8890865976",
      tenant: "CUREFIT",
      version: 0,
      memberships: [
        {
          context: "ALL",
          roleName: "ADMIN",
        },
      ],
    },
    userAccesses: [
      {
        context: "all",
        resources: [
          {
            name: "WELCOME_PAGE",
            accesses: ["READ"],
          },
        ],
      },
    ],
  },
  skipUserAccessCookie: true,
  excludes: [
    "/healthcheck",
    "/healthCheck",
    "/healthcheck/negate",
    "/healthcheck/delay",
    "/stats"
  ],
}

export const APP_STAGE = ENV.STAGE

export const IS_DEV_ENV = true
export const ALBUS_API_PREFIX = "/albus"
export const ALBUS_MULTIPART_REQUEST_API_PREFIX = "/albus-upload"
export const POLARIS_API_PREFIX = "/polaris"
export const RAMSAY_API_PREFIX = "/ramsay"
export const MEAL_SERVICE_API_PREFIX = "/mealService"
export const GMF_API_PREFIX = "/gmf"
export const METRIC_SERVICE_API_PREFIX = "/metricService"
export const LOGGING_SERVICE_API_PREFIX = "/logging"
export const EHR_SERVICE_API_PREFIX = "/ehr"
export const OLLIVANDER_API_PREFIX = "/ollivander"
export const ORION_API_PREFIX = "/orion"
export const INTERNAL_API_PREFIX = "/internal"
export const CONVERSE_API_PREFIX = "/converse-chat"
export const SUBUSER_API_PREFIX = "/subuser"
export const CARE_RECOMMENDATION_SERVICE_API_PREFIX =
  "/care-recommendation-service"
export const AWS_RES_PREFIX = "/aws/sig"
export const SHIFU_SERVICE_API_PREFIX = "/shifu"
export const DIY_FS_API_PREFIX = "/diy-fs"

export const CONVERSE_API_TARGET = "http://127.0.0.1:3790"

export const ALBUS_API_ENDPOINT_PORT = "20000"
export const ALBUS_API_ENDPOINT_HOST = "http://127.0.0.1"

export const LOGGING_SERVICE_API_ENDPOINT_HOST =
  "http://logging.stage.curefit.co"
export const LOGGING_SERVICE_API_ENDPOINT_PORT = "80"

export const BYPASS_AUTHENTICATION_URLS = ["/orion/client/dummy/track"]
export const METRIC_SERVICE_API_ENDPOINT_HOST = "http://localhost"
export const METRIC_SERVICE_API_ENDPOINT_PORT = "20000"

export const POLARIS_API_ENDPOINT_HOST = "http://127.0.0.1:8181"
export const POLARIS_API_ENDPOINT_PORT = "8181"

export const RAMSAY_API_ENDPOINT_HOST = "http://ramsay.stage.curefit.co"
export const RAMSAY_API_ENDPOINT_PORT = "80"

export const MEAL_SERVICE_API_ENDPOINT_HOST = "http://reco-api.stage.curefit.co"
export const MEAL_SERVICE_API_ENDPOINT_PORT = "80"

export const GMF_API_ENDPOINT_HOST = "http://gms.stage.curefit.co"
export const GMF_API_ENDPOINT_PORT = "80"

export const CFS_API_ENDPOINT_HOST = "https://assessment.cure.fit"
export const CFS_API_ENDPOINT_PORT = "80"

export const DIY_FS_ENDPOINT_HOST = "http://127.0.0.1"
export const DIY_FS_ENDPOINT_PORT = "5050"

export const EHR_API_ENDPOINT_HOST =
  // "http://ehr.stage.curefit.co";
  "https://ehr-stage.curefit.co"
// "http://127.0.0.1";
export const EHR_API_ENDPOINT_PORT = "80"
//  "38000";

export const OLLIVANDER_API_ENDPOINT_HOST =
  // "http://ollivander.stage.curefit.co";
  "https://ollivander-stage.curefit.co/"
// "http://127.0.0.1";
export const OLLIVANDER_API_ENDPOINT_PORT = "80"
// "36000";

export const SUBUSER_API_ENDPOINT_HOST =
  // "http://sub-user.stage.curefit.co";
  "https://sub-user-stage.curefit.co/"
// "http://127.0.0.1";
export const SUBUSER_API_ENDPOINT_PORT = "80"
// "35000";

export const CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_HOST = "http://127.0.0.1"
export const CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_PORT = "5687"

export const SHIFU_SERVICE_API_ENDPOINT_HOST = "http://127.0.0.1"
export const SHIFU_SERVICE_API_ENDPOINT_PORT = "8080"

// export const ALBUS_API_TARGET =
//   ALBUS_API_ENDPOINT_HOST + ":" + ALBUS_API_ENDPOINT_PORT
export const ALBUS_API_TARGET = "https://albus-sugarfit.stage.curefit.co"

export const POLARIS_API_TARGET = "https://polaris-stage.curefit.co/"
export const RAMSAY_API_TARGET =
  RAMSAY_API_ENDPOINT_HOST + ":" + RAMSAY_API_ENDPOINT_PORT
export const GMF_API_TARGET =
  GMF_API_ENDPOINT_HOST + ":" + GMF_API_ENDPOINT_PORT
export const METRIC_SERVICE_API_TARGET = "http://localhost:22000"
export const LOGGING_SERVICE_API_TARGET =
  LOGGING_SERVICE_API_ENDPOINT_HOST + ":" + LOGGING_SERVICE_API_ENDPOINT_PORT
export const MEAL_SERVICE_API_TARGET =
  MEAL_SERVICE_API_ENDPOINT_HOST + ":" + MEAL_SERVICE_API_ENDPOINT_PORT
export const EHR_SERVICE_API_TARGET = EHR_API_ENDPOINT_HOST //+ ":" + EHR_API_ENDPOINT_PORT;
export const OLLIVANDER_SERVICE_API_TARGET = OLLIVANDER_API_ENDPOINT_HOST // + ":" + OLLIVANDER_API_ENDPOINT_PORT;
export const SUBUSER_SERVICE_API_TARGET = SUBUSER_API_ENDPOINT_HOST // + ":" + SUBUSER_API_ENDPOINT_PORT
export const CARE_RECOMMENDATION_SERVICE_API_TARGET =
  CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_HOST +
  ":" +
  CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_PORT

export const MEAL_SERVICE_API_KEY = "J9oMSF42QNRCV0GAP0XiJ6Di8hAI7gfR"

export const REDIS_PREFIX = "CAREFIT-ORION-"
export const REDIS_HOST = "127.0.0.1"
export const REDIS_PORT = "6379"
export const REDIS_DB_INDEX = 0

export const MAVERICK_API_PREFIX = "/maverick"
export const MAVERICK_HOST = "https://maverick.stage.curefit.co"
export const MAVERICK_PORT = "35000"
// export const MAVERICK_API_TARGET = MAVERICK_HOST + ":" + MAVERICK_PORT
export const MAVERICK_API_TARGET = "https://maverick.stage.curefit.co"

export const BYPASS_AUTHENTICATION = false // Should be false for PROD.
export const AUTH_URL_SUFFIX = "/auth/google"

export const PREFERRED_AUTO_SAVE_MEDIUM = AUTO_SAVE_MEDIUMS.HTTP
export const WATCHMAN_URL = "https://watchmen.stage.curefit.co"
export const WATCHMAN_API_KEY = "synapse-stage-access"
export const SSO_CALLBACK = "http://localhost:4000"
export const HTML_PDF_QUEUE = "stage-sugarfit-synapse-html-pdf"
export const CGM_HTML_PDF_QUEUE = "stage-sugarfit-cgm-pdf-reports"

export const CDN_URL = "https://d1yfs1c2pfwbpr.cloudfront.net"
export const ORION_IMG_URL = CDN_URL + "/image/carefit/orion/"
export const IRIS_API_PREFIX = "/iris"
export const IRIS_HOST = "http://iris.stage.curefit.co"

export const USER_FITNESS_PREFIX = "/user-fitness"
export const USER_FITNESS_HOST = "http://127.0.0.1"
export const USER_FITNESS_PORT = "5030"
export const USER_FITNESS_API_TARGET =
  USER_FITNESS_HOST + ":" + USER_FITNESS_PORT

export const HERCULES_SERVICE_PREFIX = "/hercules"
export const HERCULES_SERVICE_HOST = "http://127.0.0.1"
export const HERCULES_SERVICE_PORT = "9009"
export const HERCULES_SERVICE_API_TARGET =
  HERCULES_SERVICE_HOST + ":" + HERCULES_SERVICE_PORT

export const AUTOMATED_WORKING_HOURS_ALLOWED_AGENT_TYPES: string[] = [
  "DOCTOR",
  "LIFESTYLE_COACH",
  "MIND_THERAPIST",
]

export const SHIFU_SERVICE_API_TARGET = "https://shifu-backend.stage.curefit.co"
// export const SHIFU_SERVICE_API_TARGET = SHIFU_SERVICE_API_ENDPOINT_HOST + ":" + SHIFU_SERVICE_API_ENDPOINT_PORT;

export const DIY_FS_API_TARGET =
  DIY_FS_ENDPOINT_HOST + ":" + DIY_FS_ENDPOINT_PORT

export const AMBROSIA_API_PREFIX = "/ambrosia"
export const AMBROSIA_API_TARGET = "https://ambrosia.stage.curefit.co"

export const CHS_API_PREFIX = "/chs"
export const CHS_API_TARGET = "https://chs.stage.curefit.co"

export const ALFRED_API_PREFIX = "/alfred"
export const ALFRED_API_TARGET = "http://localhost:3011"

export const SUBSCRIPTION_MANAGER_API_PREFIX = "/subscription-manager"
export const SUBSCRIPTION_MANAGER_API_TARGET =
  "https://sugarfit-subscription-manager.stage.curefit.co"

export const USER_SERVICE_API_PREFIX = "/user-service"
export const USER_SERVICE_API_TARGET = "http://localhost:5001"

export const NEST_SERVICE_API_PREFIX = "/nest"
export const NEST_SERVICE_API_TARGET = "https://nest.stage.curefit.co"

export const ODIN_API_PREFIX = "/odin"
export const ODIN_API_TARGET = "https://odin.stage.curefit.co"

export const SUGARFIT_CMS_API_PREFIX = "/sugarfit-cms"
export const SUGARFIT_CMS_API_TARGET = "https://sugarfit-cms.stage.curefit.co";
// export const SUGARFIT_CMS_API_TARGET = "http://localhost:8082"

export const FUSE_SERVICE_API_PREFIX = "/fuse"
export const FUSE_SERVICE_API_TARGET = "https://fuse-stage.curefit.co/"

export const HOUSEMD_SERVICE_API_PREFIX = "/housemd"
// export const HOUSEMD_SERVICE_API_TARGET = "https://housemd.stage.curefit.co"
export const HOUSEMD_SERVICE_API_TARGET = "http://localhost:8003"

export const LMS_SERVICE_API_PREFIX = "/lms"
export const LMS_SERVICE_API_TARGET = "https://sf-lms.stage.curefit.co"

export const CONVERSE_SERVICE_API_PREFIX = "/converse"
export const CONVERSE_SERVICE_API_TARGET = "https://converse.stage.curefit.co"

export const INDUS_API_PREFIX = "/indus"
export const INDUS_API_TARGET = "https://indus.stage.curefit.co/"
// export const INDUS_API_TARGET = "http://localhost:8383";

export const OMS_API_PREFIX = "/oms"
export const OMS_API_TARGET = "http://localhost:8282/"

export const SEGMENTATION_SERVICE_API_PREFIX = "/segmentation-service"
export const SEGMENTATION_SERVICE_API_TARGET =
  "https://segmentation.stage.curefit.co/"

export const SKYNET_API_PREFIX = "/skynet"
export const SKYNET_API_TARGET = "http://localhost:8082/"
export const APP_CONFIG_API_PREFIX = "/app-config-cache"

export const API_KEYS = {
  ALBUS: "f8870e147ab0f4686118aa83bddfbe88f0771236Îß",
  HERCULES: "MFM4kAiMG0yfpW9x3q9xo6sPT4zX792W",
  SHIFU: "shifu-ui-stage-access",
}

export const TENANT = "SUGARFIT"

export const ODIN_API_KEY = "synapse-stage-access"

export const ODIN_SOURCE = "SUGARFIT"
export const ODIN_SOURCE_REF_ID = 1

export const ODIN_FIELDS_CONFIG = {
  UHID: 462,
  CATEGORY: 370,
  SUB_CATEGORY: 371,
  TITLE: 339,
  DESCRIPTION: 340,
  PRIORITY: 341,
}

export const ODIN_CATEGORY_CONFIG = {
  TECH_ISSUE: 191,
}

export const ODIN_SUB_CATEGORY_CONFIG = {
  EMR_ISSUE: 202,
}

export const ODIN_PRIORITY_CONFIG = {
  [ODIN_CATEGORY_CONFIG.TECH_ISSUE]: { CODE_RED: 481, HIGH: 482, MEDIUM: 483 },
}
